<template>
  <div v-if="product" class="eCartItem">
    <EditCartItemBody
      :product="product"
      :variantId="variantId"
      :line="line"
      :lineKey="lineKey"
      :quantity="quantity"
      :isCartUpsell="isCartUpsell"
    />
  </div>
  <div v-else class="eCartItem__loader eCartItem--processing"></div>
</template>

<script setup>
  import { ref, onBeforeMount } from 'vue';
  import EditCartItemBody from './edit-cart-item-body.vue';

  const props = defineProps({
    drawerHeading: {
      type: String,
      default: '',
    },

    productData: {
      type: Object,
      default: null,
    },

    variantId: {
      type: String,
      default: '',
    },

    productHandle: {
      type: String,
      default: '',
    },

    line: {
      type: String,
      default: '',
    },

    lineKey: {
      type: String,
      default: '',
    },

    quantity: {
      type: String,
      default: '',
    },

    isCartUpsell: {
      type: Boolean,
      default: false,
    }
  })

  const emit = defineEmits(['heading', 'component-updated']) 
  const product = ref(null)

  onBeforeMount(() => {
    emit('heading',props.drawerHeading)
    if(props.productData){
      product.value = props.productData
      emit('component-updated');
    }else{
      getProductData()
    }
  })

  const getProductData = async() =>{
    await fetch(`/products/${props.productHandle}?view=json`)
    .then(resp => resp.json())
    .then(data =>{
      product.value = data;
      emit('component-updated');
    }) 
  };
</script>